import { configureStore } from '@reduxjs/toolkit';
import organizationSlice from '../features/organization/organizationSlice';
import storage from 'redux-persist/lib/storage';
import userSliceReducer from '../features/user/userSlice';
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import bitbucketSlice from '../features/bitbucket/bitbucketSlice';
import permissionSlice from '../features/permission/permissionSlice';
import editorSlice from '../features/editior/editorSlice';
import notificationSlice from '../features/notifications/notificationSlice';
import aiSlice from './../features/ai';
import { searchApi } from '../features/search/searchApi';
import { announcementApi } from '../features/announcements/announcementApi';
import templateSlice from '../features/template/template';
import announcementSlice from '../features/announcement/announcement';
import newsletterSlice from '../features/announcements/newsletterSlice';
import { suggesstionApi } from '../features/suggesstions/suggesstionApi';
import { filePermissionApi } from '../features/filePermissions/filePermissionApi';
import { aiApi } from '../features/ai/aiApi';
import { templatesApi } from '../features/template/templatesApi';
import { onedocSiteApi } from '../features/onedocSite/onedocSiteApi';
import siteBuilderReducer from '../features/onedocSite/siteBuilderSlice';

const persistConfig = {
  key: 'user',
  storage,
  blacklist: ['authError'],
};

const persistedReducer = persistReducer(persistConfig, userSliceReducer);

export const store = configureStore({
  reducer: {
    user: persistedReducer,
    organization: organizationSlice,
    bitbucket: bitbucketSlice,
    permission: permissionSlice,
    editor: editorSlice,
    newsletterSlice: newsletterSlice,
    notification: notificationSlice,
    ai: aiSlice,
    template: templateSlice,
    announcement: announcementSlice,
    [searchApi.reducerPath]: searchApi.reducer,
    [announcementApi.reducerPath]: announcementApi.reducer,
    [suggesstionApi.reducerPath]: suggesstionApi.reducer,
    [filePermissionApi.reducerPath]: filePermissionApi.reducer,
    [aiApi.reducerPath]: aiApi.reducer,
    [templatesApi.reducerPath]: templatesApi.reducer,
    [onedocSiteApi.reducerPath]: onedocSiteApi.reducer,
    siteBuilder: siteBuilderReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: {},
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    })
      .concat(searchApi.middleware)
      .concat(announcementApi.middleware)
      .concat(suggesstionApi.middleware)
      .concat(filePermissionApi.middleware)
      .concat(aiApi.middleware)
      .concat(templatesApi.middleware)
      .concat(onedocSiteApi.middleware),
});

export const persistor = persistStore(store);
